<template>
  <div class="filter-view h-100">
      <div class="row g-0 h-100">

          <div class="menu-btn" v-if="!showMenuBool">
              <button  @click="showMenu()">
                  <i class="bi bi-card-list"></i> Show Keypad
              </button>
          </div>

          <div id="myStackernav" class="stackernav">
              <button class="close-btn" @click="showMenu()">
                  <i class="bi bi-x"></i>
              </button>
              <div class="filters ">
                  <div class="pt-5 heading">
                      <h2 class="mt-3">Enter Door ID.</h2>
                  </div>
                  <div class="filter-box mt-3">
                      <div class="input">
                          <input type="text" maxlength="2" v-model="FetchNumber"/>
                      </div>

                      <div class="btn-boxes">
                          <div class="d-flex justify-content-between flex-wrap wrap-3 btns-wrap">
                              <div>
                                  <div class="box d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(1)">1</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-2 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(2)">2</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-3 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(3)">3</button>
                                  </div>
                              </div>

                              <div>
                                  <div class="box d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(4)">4</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-2 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(5)">5</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-3 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(6)">6</button>
                                  </div>
                              </div>

                              <div>
                                  <div class="box d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(7)">7</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-2 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(8)">8</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-3 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(9)">9</button>
                                  </div>
                              </div>

                              <div>
                                  <div class="box d-flex align-items-center justify-content-center mt-3">
                                      <button @click="Backspace()">
                                          <i class="bi bi-backspace-fill"></i>
                                      </button>                                        
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-2 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(0)">0</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-3 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="FilterApply()"><i class="bi bi-arrow-right"></i></button>                                        
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="col-md-3 desktop">
              <div class="filters">
                  <div class="pt-5 heading">
                      <h2 class="mt-3">Enter Door ID.</h2>
                  </div>
                  <div class="filter-box mt-3">
                      <div class="input">
                          <input type="text" maxlength="2" v-model="FetchNumber"/>
                      </div>

                      <div class="btn-boxes">
                          <div class="d-flex justify-content-between flex-wrap wrap-3 btns-wrap">
                              <div>
                                  <div class="box d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(1)">1</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-2 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(2)">2</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-3 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(3)">3</button>
                                  </div>
                              </div>

                              <div>
                                  <div class="box d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(4)">4</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-2 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(5)">5</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-3 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(6)">6</button>
                                  </div>
                              </div>

                              <div>
                                  <div class="box d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(7)">7</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-2 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(8)">8</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-3 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(9)">9</button>
                                  </div>
                              </div>

                              <div>
                                  <div class="box d-flex align-items-center justify-content-center mt-3">
                                      <button @click="Backspace()">
                                          <i class="bi bi-backspace-fill"></i>
                                      </button>                                        
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-2 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="GetNumber(0)">0</button>
                                  </div>
                              </div>
                              <div>
                                  <div class="box b-3 d-flex align-items-center justify-content-center mt-3">
                                      <button @click="FilterApply()"><i class="bi bi-arrow-right"></i></button>                                        
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-md-8 h-100 desktop-2">
              <div class="h-100 list-view">
                  <SearchFilterList :fromcms="false" :data="apartments"/>
              </div>                
          </div>
      </div>
  </div>
</template>

<script>
import SearchFilterList from "@/components/SearchFilterList/SearchFilterList.vue";

export default {
name: 'SearchKeypadView',
components: {
  SearchFilterList,
},
data(){
  return {
      FetchNumber:"",
      apartments: [],
      apartments_two: [],
      showMenuBool: true,
  }
},
 created() {
      this.GetApartments();
      this.PageViewCount();
      document.title = "Keypad Search - Heybourne Park"
  },
  methods: {
      GetApartments(){
          fetch(this.base_url+'GetAllApartments')
          .then(response => response.json())
          .then(res => {
              //console.log(res.data.apartments)
              this.apartments = res.data.apartments;
              this.apartments_two = [...res.data.apartments]
          });
      },
      GetNumber(value){
          this.FetchNumber = this.FetchNumber.toString() + value.toString();
      },
      Backspace(){
          this.FetchNumber = this.FetchNumber.slice(0,-1);
          this.apartments = this.apartments_two
      },
      FilterApply(){
         // this.$emit('NumFilter', this.FetchNumber)
          this.apartments = this.apartments_two.filter((e)=>{
              return e.id == this.FetchNumber;
          });
          this.showMenuBool = false;
          document.getElementById('myStackernav').style.width = "0px";
         
      },
      showMenu(){
          if (document.getElementById('myStackernav').offsetWidth == 0) {
              this.showMenuBool = true;
              if(window.innerWidth >= 768){
                  document.getElementById('myStackernav').style.width = "350px";
              }else{
                  document.getElementById('myStackernav').style.width = "350px";
              }
          } else {
              this.showMenuBool = false;
              document.getElementById('myStackernav').style.width = "0px";
          }
      },
      PageViewCount(){
          if(sessionStorage.getItem('session_id') != null){
              let data = { 
                  session_id: sessionStorage.getItem('session_id'),
                  page_name: "Search Keypad"
              }
              fetch(this.base_url+'AddPageView',{
                  method: 'POST', // or 'PUT'
                  headers: {
                      
                  },
                  body: JSON.stringify(data),
                  })
              .then(response => response.json())
              .then(res => {
                  
              });
          }
      }
  },
}

</script>

<style scoped lang="scss">
* {
  font-family: "rustica-regular" !important;
}


.menu-btn {
position: absolute;
z-index: 999;
display: none;
  width:auto;
button {
  border: none;
  background: #cad636;
  color: #fff;
  width: auto;
  height: 35px;
  margin: 20px;
  font-size: 14px;
  padding:0 10px
}
}

.filter-view {
  //background:url('../assets/img/background.jpg');
  background: #381b31;
}

.stackernav {
  display: none;
  height: calc(100% - 70px);
  width: 0;
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0;
  bottom: 0;
  background-color: #381b31;
  overflow-x: hidden;
  transition: 0.5s;
  margin-top: 0;
  .close-btn {
      border: none;
      position: absolute;
      top: 10px;
      right: 15px;
      background: transparent;
      i{
          color: #cad636;
          font-size: 35px;
      }
  }
}

.filters {
  //background: #355063;
  height: 100%;
  padding-bottom: 50px;
  .heading {
      color: #fff;
      text-transform: uppercase;
      width: 80%;
      margin: 0 auto;
  }

  .filter-box {
      width: 80%;
      margin: auto;

      .input {
          input {
              width: 100%;
              height: 40px;
              text-align: center;
              outline: none;
          }
      }

      .btn-boxes{ 
          .btns-wrap{
              div{ 
                  flex: 33%;
                  .box{
                      width: 50px;
                      height: 50px;
                      color: #fff;
                      font-size:24px;
                      border:1px solid #fff;
                      &:hover{
                              background: #cad636 !important;
                          }
                      button{
                          background: transparent;
                          border: none;
                          color: #fff;
                          width: 100%;
                          height: 30px;
                      }
                  }

                  .b-2{ margin: 0 auto}
                  .b-3{ float: right }
              }
          }
      }
  }
}

@media screen and (max-width: 1024px) and (orientation: landscape) {
  .filters{
      height:auto !important;
  }
}

@media screen and (max-width: 1024px) {
  .filters{
      height:100%;
  }
  .desktop{
      display: none!important;
      &::-webkit-scrollbar {
          width: 0px;
      }    
  }
  .menu-btn{
      display: block;
  }
  .desktop-2{
      width: 100%!important;
  }
  .stackernav{
      display: block;
      width:350px
  }
}

@media screen and (max-width: 767px) {
  .vfm--fixed {
      width: 100% !important;
      left: 0 !important;
      top: 70px !important;
      z-index: 2014 !important;
  }

  .stackernav {
      top: 70px;
  }

  .filter-view {
    margin-top:70px
  }

}

@media screen and (max-width: 1024px) {
  .filter-view {
    margin-top:70px !important
  }

  .filter-view .row {
      height: unset !important;
  }
}

</style>